import { ChangeEvent, useState, useCallback } from 'react';

export const useWalletConnectUri = () => {
    const [walletConnectUri, setWalletConnectUri] = useState('');

    const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        setWalletConnectUri(e.target.value);
    }, []);

    return { walletConnectUri, handleChange };
};
